import { useCallback, useState } from 'react'

import { v4 as uuid } from 'uuid'

import { QuillModules, StyledQuill } from '../../../components/form/RichTextInput'
import { KeyboardKey } from '../../../types'
import FormControl from '../FormControl/FormControl'
import { FormControlProps } from '../FormControl/util'

type Props = FormControlProps & {
  value: string
  onValueChange: (value: string) => void
}
const RichTextInput = ({
  caption,
  errorMessage,
  id: propId,
  isInvalid,
  isRequired,
  label,
  onValueChange,
  tooltip,
  value,
  width,
}: Props) => {
  const [id] = useState(propId ?? uuid())
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === KeyboardKey.K && (e.metaKey || e.ctrlKey)) {
      e.stopPropagation()
    }
  }, [])

  return (
    <FormControl
      caption={caption}
      errorMessage={errorMessage}
      id={id}
      isInvalid={isInvalid}
      isRequired={isRequired}
      label={label}
      tooltip={tooltip}
      width={width}
    >
      {() => (
        <StyledQuill
          value={value}
          onChange={onValueChange}
          theme="snow"
          modules={QuillModules}
          onKeyDown={handleKeyDown}
        />
      )}
    </FormControl>
  )
}

export default React.memo(RichTextInput)
